
import { Fragment, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { BasicExamTable } from "../common/BasicExamTable";
import { checkApi } from "../../Authentication/AxiosInstance";
import LoadingPage from "../common/LoadingPage";
import ErrorPage from "../common/ErrorPage";
import DisclaimerBanner from "../common/Disclaimers";
//const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const DEFAULT_ACADEMIC_YEAR = process.env.REACT_APP_DEFAULTACADEMICYEAR;
console.log(DEFAULT_ACADEMIC_YEAR)
export const ExamDates = () => {
  const [error, setError] = useState(null);
  const fetchExamDates = async () => {
    //const fetchUrl = new URL(`${API_ENDPOINT}/examdates/`);
    const fetchUrl = '/cetzone/examdates/'
    const params = {
      academic_year: DEFAULT_ACADEMIC_YEAR,
    }
    console.log(fetchUrl);
    try {
    const res = await checkApi.get(fetchUrl, { params });
    return res.data;
    } catch (error) {
      console.error("Error fetching exam dates:", error);
      setError(error.message);
    }
  };

  const { data, status } = useQuery({
    queryKey: ["examdates"],
    queryFn: fetchExamDates,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    throwOnError: false,
  });

  const dateFormatFn = (v_date) => {
    console.log(v_date)
    if (!v_date || typeof v_date !== 'string') return null; // Prevent undefined errors
    const dateObj = new Date(v_date)
    if (v_date.length <= 10)
      return dateObj.toLocaleDateString("en-GB", { month: "short", day: "2-digit", year: "2-digit" });
    else
      return dateObj.toLocaleDateString("en-GB",{ month: "short", day: "2-digit", year: "2-digit"} ) + " " + dateObj.toLocaleTimeString("en-GB", { hour:'numeric', minute:'numeric', hour12: true }).toUpperCase();
  };
 
  
  const columns = useMemo(()=>[
      {
        header: "Exam Name",
        accessorFn: (row) => `${row.edt_exam_name} - ${row.edt_exam_session}`,
        enableColumnFilter: false, // disable column filtering for this column
        custom_getActivityStatus: false,
      },
      {
        header: "Application Information",
        columns: [
          {
            header: "Application Start & End Dates",
            accessorFn: (row) => {
              const startDate = dateFormatFn(row.edt_application_startdate);
              const endDate = dateFormatFn(row.edt_application_enddate);
              const endDates = row.edt_application_enddates || [];
              const formattedEndDates = endDates?.map(d => `${dateFormatFn(d.date)} (${d.remark})`).join("\n");
               // Construct final display format
              let result = startDate ? `${startDate}\nto\n` : "";
              result += endDate ? `${endDate}\n` : "";
              result += formattedEndDates ? `${formattedEndDates}` : "";
              return result.trim() || row.edt_application_remarks;
            },
            enableColumnFilter: false, // disable column filtering for this column
            cell: ({ getValue }) => {
                    const value = getValue()
                    if (!value ||!value.includes("\nto\n")) {
                      return <span style={{ color: "gray" }}>No Data</span>;
                    }
                    const [start, ...endParts] = value.split("\nto\n");
                    const [end, ...extensions] = endParts.join("\nto\n").split("\n");
                    return (
                      <span className="flex flex-col items-center max-w-64 whitespace-nowrap">
                        {start || "N/A"}
                        <strong>to</strong>
                        {end || "N/A"}
                        {extensions.map((line, index) => (
                          <span key={index}>{line}</span>
                        ))}
                      </span>
                    );
                  },
            custom_getActivityStatus: true,
          },
          {
            header: "Pay Fees By",
            accessorFn: (row) => {
              const feePaymentDate = dateFormatFn(row.edt_exam_feepaymentby_date);
              return feePaymentDate ? `${feePaymentDate}` : "To Be Announced";
            },
            enableColumnFilter: false, // disable column filtering for this column
            cell: ({ getValue }) => (
                  <div className="whiteSpace-nowrap">
                    {getValue()}
                  </div>
                ),
            custom_getActivityStatus: true,
          },
          {
            header: "Application Correction Window",
            accessorFn: (row) => {
              const startDate = dateFormatFn(row.edt_appcorrection_startdate);
              const endDate = dateFormatFn(row.edt_appcorrection_enddate);
              const endDates = row.edt_appcorrection_enddates || []; //json field
              const formattedEndDates = endDates?.map(d => `${dateFormatFn(d.date)} (${d.remark})`).join("\n");
              
              // Construct final display format
              let result = startDate ? `${startDate}\nto\n` : "";
              result += endDate ? `${endDate}\n` : "";
              result += formattedEndDates ? `${formattedEndDates}` : "";
              return result.trim() || row.edt_appcorrection_remarks;
            },
            enableColumnFilter: false, // disable column filtering for this column
            cell: ({ getValue }) => {
                    const value = getValue()
                    if (!value ||!value.includes("\nto\n")) {
                      return <span style={{ color: "gray" }}>To Be Announced</span>;
                    }
                    const [start, ...endParts] = value.split("\nto\n");
                    const [end, ...extensions] = endParts.join("\nto\n").split("\n");

                    return (
                      <span className="flex flex-col items-center max-w-64 whitespace-nowrap">
                        {start || "N/A"}
                        <strong>to</strong>
                        {end || "N/A"}
                        {extensions.map((line, index) => (
                          <span key={index}>{line}</span>
                        ))}
                      </span>
                    );
                  },
            custom_getActivityStatus: true,
          },
        ],
      },
      {
        header: "Exam Information",
        columns: [
          // {
          //   accessorKey: "edt_exam_mode",
          //   header: "Mode",
          //   accessorFn: (row) => {
          //     return row.edt_exam_mode ? row.edt_exam_mode : 'No Data Available';
          //   },
          //   enableColumnFilter: false, // disable column filtering for this column
          // },
          {
            header: "Admit Card",
            accessorFn: (row) => {
              const admitCardDate = dateFormatFn(row.edt_admitcard_date);
              return admitCardDate ? `${admitCardDate}` : row.edt_admitcard_remarks;
            },
            enableColumnFilter: false, // disable column filtering for this column
            cell: ({ getValue }) => (
                  <div className="text-center whiteSpace-nowrap">
                    {getValue()}
                  </div>
                ),
            custom_getActivityStatus: true,
          },
          {
            header: "Exam Dates",
            accessorFn: (row) => {
              console.log(row.edt_exam_dates_remarks)
              const examDates = Array.isArray(row.edt_exam_dates) ? row.edt_exam_dates : [];
              console.log(examDates.length)
              const returnValue = examDates.length > 0 
                    ? examDates.join(",\n") //row.edt_exam_dates.map(dateFormatFn).join(',\n') 
                    : row.edt_exam_dates_remarks 
                    ?? 'TBA'
              console.log(returnValue)
              return returnValue
            },
            enableColumnFilter: false, // disable column filtering for this column
            cell: ({ getValue }) => {
              const value = getValue();
              console.log(value)
              return (
                  <div className="break-words">
                    {value 
                    ? value.split(",").map((item, index) => {
                        const trimmedItem = item.trim();
                        // Check if item contains 'to' and wrap it
                        if (trimmedItem.includes(' to ')) {
                          const [start, end] = trimmedItem.split(' to ');
                          return (
                            <div key={index} className="break-words whitespace-normal">
                              {start.trim()}
                              <br />
                              <span className="font-semibold">to</span>
                              <br />
                              {end.trim()}
                            </div>
                          );
                        }
                        return (
                          <div key={index} className="break-words whitespace-normal">{trimmedItem}</div>
                        );
                      })
                    : "No Data"}
                  </div>
                )},
            custom_getActivityStatus: true,
          },
          { 
            header: "Answer Sheet Review",
            accessorFn: (row) => {
              const qpak_rc_date = dateFormatFn(row.edt_qpak_rc_date);
              return qpak_rc_date || row.edt_qpak_rc_remarks || "To Be Announced";
            },
            enableColumnFilter: false, // disable column filtering for this column
            cell: ({ getValue }) => (
                  <div className="text-center whiteSpace-nowrap">
                    {getValue()}
                  </div>
                ),
            custom_getActivityStatus: true,
          },
          {
            header: "Results",
            accessorFn: (row) => {
              const resultDate = dateFormatFn(row.edt_resultdate);
              return resultDate ? `${resultDate}` : "To Be Announced";
            },
            enableColumnFilter: false, // disable column filtering for this column
            cell: ({ getValue }) => (
              <div className="text-center">
                  {getValue()}
              </div>
            ),
            custom_getActivityStatus: true,
          },
        ],
      },
      

  ],[]
  );
  
  console.log(columns)
  console.log(data)
  return (
    <Fragment>
      {status === "pending" ? (
        <LoadingPage />
      ) : (status === "error" || error) ? (
        <ErrorPage />
      ) : data?.length > 0 ? (
              <div className="w-full max-w-full overflow-hidden">
                <BasicExamTable data={data} columns={columns}/>
                <DisclaimerBanner/>
              </div>
      ) : (
          <ErrorPage nodatafound="No Exam Schedules available"/>)
      }
      
    </Fragment>
  );
};

